import { Wind, Sparkles } from 'lucide-react';
import { DiscoveryCard } from './discovery-card';
import { SourceLinks } from '@/components/ui/source-links';

interface PoeticFeatureCardProps {
  feature: {
    feature: string;
    description: string;
    ref?: string;
    sources?: Source[];
  };
}

export function PoeticFeatureCard({
  feature
}: PoeticFeatureCardProps) {
  return (
    <DiscoveryCard
      isExpanded={true}
      onToggle={() => { }}
      canExpand={false}
      icon={Wind}
      header={
        <div className="flex flex-col gap-3 flex-1 min-w-0 relative z-10">
          <div className="flex items-center justify-between gap-2">
            <h4 className="text-xl font-serif font-medium tracking-tight text-foreground/90 leading-tight">
              {feature.feature}
            </h4>
            {feature.ref && (
              <span className="text-xs font-medium text-muted-foreground bg-muted/50 px-2 py-0.5 rounded-full">
                {feature.ref}
              </span>
            )}
          </div>
        </div>
      }
    >
      <div className="space-y-4 mt-1 relative z-10">
        <p className="text-sm text-foreground/70 font-light leading-relaxed px-1">
          {feature.description}
        </p>

        {feature.sources && feature.sources.length > 0 && (
          <div className="pt-4 border-t border-border/10">
            <SourceLinks sources={feature.sources} />
          </div>
        )}
      </div>
    </DiscoveryCard>
  );
}
